// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__itbVa","Div":"CustomFadeBox_Div__1aS9n","LargeDiv":"CustomFadeBox_LargeDiv__3DZNb"};